function buildHeaders(apiKey) {
    const headers = {
        "Content-Type": "application/json; charset=UTF-8;"
    };

    if (apiKey) {
        headers["X-Authorization"] = apiKey;
    }

    return headers;
}

async function getAccountPaymentsSettings(params) {
    try {
        const response = await fetch(`${params.apiBase}/v2/accounts/${params.accountSlug}?expand[finance_settings]=*`, {
            headers: buildHeaders(),
            method: "GET"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('getAccountPaymentsSettings failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function createNewDeal(params, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(),
            method: "POST"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('createNewDeal failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function getDealRevisions(params, getPerson = false) {
    const fetchURL = getPerson ?
        `${params.apiBase}/v2/deals/${params.uuid}?expand[vehicles]=*&expand[person]=*` :
        `${params.apiBase}/v2/deals/${params.uuid}?expand[vehicles]=*`;

    try {
        const response = await fetch(fetchURL, {
            headers: buildHeaders(params.api_key),
            method: "GET"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('getDealRevisions failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function patchPayment(params, vin, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/vehicles/${vin}/payment`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "PATCH"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('patchPayment failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function getMonthlyPayments(osSlug, vin, baseUrl) {
    try {
        const response = await fetch(`${baseUrl}/v2/offers/accounts/${osSlug}/vehicles/${vin}`, {
            headers: buildHeaders(),
            method: "GET"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('getMonthlyPayments failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function patchPerson(params, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/person`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "PATCH"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('patchPerson failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function getTradePending(params, reqQuery) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/tradepending/api/v3/select/?${reqQuery}`, {
            headers: buildHeaders(params.api_key),
            method: "GET"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('getTradePending failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function patchTradeIn(params, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/tradein`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "PATCH"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('patchTradeIn failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function getTradePendingReport(params, reqQuery) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/tradepending/api/v3/report?${reqQuery}`, {
            headers: buildHeaders(params.api_key),
            method: "GET"
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('trade pending report failed with a bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function deleteTradePending(params) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/tradein`, {
            headers: buildHeaders(params.api_key),
            method: "DELETE"
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('delete trade in failed with bad status code');
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function checkLenderLogo(params, lenderName) {
    try {
        const response = await fetch(`${params}/v2/banks/${lenderName}/logo`, {
            method: "GET"
        });
        if (response.ok) {
            return response.url;
        } else {
            return false;
        }
    } catch (err) {
        throw new Error(err);
    }
}

async function postToReserve(params, vin, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/vehicles/${vin}/reserve`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "POST"
        });

        if (response.ok) {
            return true;
        } else {
            throw new Error('failed to reserve vehicle');
        }
    } catch (error) {
        throw new Error(error);
    }
}

async function postToPickUp(params, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/appointment/pick_up`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "POST"
        });

        if (response.ok) {
            return true;
        } else {
            throw new Error('unable to schedule appointment');
        }
    } catch (error) {
        throw new Error(error);
    }
}

async function patchTrackingData(params, reqBody) {
    try {
        const response = await fetch(`${params.apiBase}/v2/deals/${params.uuid}/tracking`, {
            body: JSON.stringify(reqBody),
            headers: buildHeaders(params.api_key),
            method: "PATCH"
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('unable to append tracking data');
        }

    } catch (error) {
        throw new Error(error);
    }
}

const fetchRequest = {
    buildHeaders,
    getAccountPaymentsSettings,
    createNewDeal,
    getDealRevisions,
    patchPayment,
    patchPerson,
    getMonthlyPayments,
    getTradePending,
    patchTradeIn,
    getTradePendingReport,
    deleteTradePending,
    checkLenderLogo,
    postToReserve,
    postToPickUp,
    patchTrackingData
};

export default fetchRequest;